import React from 'react';
import Icon from '../../../components/AppIcon';
import InfoTooltip from '../../../components/ui/Tooltip';

const KPICard = ({
  title,
  value,
  subtitle,
  icon,
  trend = null,
  trendDirection = 'up',
  variant = 'default', // on le garde pour compat, mais le style reste neutre
  tooltip = null
}) => {
  return (
    <div
      className="
        rounded-2xl bg-white
        border border-gray-100
        shadow-sm
        p-4
        flex flex-col gap-2
      "
    >
      {/* Title row */}
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        {icon && <Icon name={icon} size={16} className="text-muted-foreground" />}
        <span className="leading-none">{title}</span>
        {tooltip && (
          <span className="ml-1">
            <InfoTooltip content={tooltip} />
          </span>
        )}
      </div>

      {/* Value */}
      <div className="text-2xl font-semibold text-gray-900 leading-tight">
        {value}
      </div>

      {/* Subtitle (optional) */}
      {subtitle && (
        <div className="text-sm text-muted-foreground leading-snug">
          {subtitle}
        </div>
      )}

      {/* Trend (optional) */}
      {trend && (
        <div className="flex items-center gap-1.5 pt-1">
          <Icon
            name={trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown'}
            size={16}
            color={trendDirection === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
          />
          <span
            className={`text-sm font-medium ${
              trendDirection === 'up' ? 'text-success' : 'text-error'
            }`}
          >
            {trend}
          </span>
        </div>
      )}
    </div>
  );
};

export default KPICard;
